var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVipLargeIcon = function SvgVipLargeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 35,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5E6",
    stroke: "#FAA61A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5,
    d: "M2.827 23.02V6.09c0-2.35 1.36-2.916 3.022-1.255l4.577 4.577c.69.69 1.82.69 2.492 0l6.327-6.344c.69-.69 1.82-.69 2.492 0l6.345 6.344c.689.69 1.82.69 2.492 0l4.577-4.577c1.661-1.661 3.022-1.096 3.022 1.255v16.949c0 5.301-3.535 8.836-8.837 8.836H11.664c-4.878-.018-8.836-3.976-8.836-8.854Z"
  })));
};
export default SvgVipLargeIcon;